import { render } from "./DetailContainer.vue?vue&type=template&id=a39e1974&scoped=true"
import script from "./DetailContainer.vue?vue&type=script&lang=js"
export * from "./DetailContainer.vue?vue&type=script&lang=js"

import "./DetailContainer.vue?vue&type=style&index=0&id=a39e1974&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a39e1974"]])

export default __exports__